import { Amplify, Auth, Hub } from "aws-amplify";
import { CognitoUser } from "@aws-amplify/auth";
import { BehaviorSubject } from "rxjs";
import { getLocale } from "./langHelper";
import { SumsubApplicantStatus } from "./sumsubService/sumsubService";

// Anything exported from this file is importable by other in-browser modules.
export type UserAuth = {
  cognitoUser?: CognitoUser;
  error: boolean;
  pending?: boolean;
};

export const $auth = new BehaviorSubject<UserAuth>({
  error: false,
  pending: true,
});
const lang = getLocale();
Amplify.configure({
  Auth: {
    userPoolId: process.env.USER_POOL_ID,
    userPoolWebClientId: process.env.USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.OAUTH_DOMAIN,
      scope: ["email", "openid"],
      redirectSignIn: `${process.env.BASE_URL}/${lang}/register`,
      redirectSignOut: `${process.env.BASE_URL}/${lang}/`,
      responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
});
Hub.listen("auth", (data) => {
  switch (data.payload.event) {
    case "signIn":
      console.log("user signed in");
      $auth.next({
        cognitoUser: data.payload.data,
        error: false,
        pending: false,
      });
      break;
    case "cognitoHostedUI":
      console.log("cognitoHostedUI", data.payload.data);
      break;
    case "signUp":
      console.log("user signed up");
      break;
    case "signOut":
      console.log("user signed out");
      $auth.next({
        cognitoUser: null,
        error: false,
        pending: false,
      });
      break;
    case "signIn_failure":
      console.log("user sign in failed");
      break;
    case "configured":
      console.log("the Auth module is configured");
  }
});
Auth.currentAuthenticatedUser()
  .then((user: CognitoUser) => {
    $auth.next({
      cognitoUser: user,
      error: false,
      pending: false,
    });
  })
  .catch((reason) => {
    $auth.next({
      cognitoUser: null,
      error: false,
      pending: false,
    });
  });
export const $sumsubApplicantStatus =
  new BehaviorSubject<SumsubApplicantStatus>(null);
export { getJwtToken } from "./getJwtToken";
export {
  initSumsub,
  destroySumsub,
  SumsubApplicantStatusReviewStatus,
  SumsubApplicantStatusLevelName,
} from "./sumsubService/sumsubService";
